import useMutate from '../../hooks/api/useMutate';
import { useMemo } from 'react';
import useApi from '../../hooks/api/useApi';

export function useInitiateSubscription() {
  const { post, isMutating } = useMutate('/payment/initiate/subscription');

  const initiateSubscription = async ({ merchant_id, plan_id, billing_cycle, source }) => {
    const res = await post({
      merchant_id,
      plan_id,
      billing_cycle,
      source
    });

    return { gateway: res?.gateway, ...(res?.data ?? {}) };
  };

  return {
    initiateSubscription,
    isMutating
  };
}

export function usePaymentStatus(txnid) {
  const shouldFetch = Boolean(txnid);

  const url = shouldFetch ? `/payment/status/${txnid}` : null;

  const { data, error, isLoading, refresh } = useApi(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  const payment = useMemo(
    () => ({
      status: data?.data?.status || 'loading',
      message: data?.data?.message || '',
      detail: data?.data?.detail || null,
      // Price, GST and total as charged, for plans, add-ons and extra
      // locations. Null for anything else, and for payments made before GST.
      gst: data?.data?.gst || null,
      should_poll: data?.data?.should_poll || false,
      source: data?.data?.source,
      slug: data?.data?.restaurant_slug
    }),
    [data]
  );

  return {
    payment,
    error,
    isLoading,
    refresh
  };
}

/**
 * The add-ons on sale, with their prices and the GST on them. Fetched only when
 * asked for (pass false to skip), because the modal that needs it is mounted on
 * pages where it is never opened.
 */
export function useGetAddons(enabled = true) {
  const { data, error, isLoading } = useApi(enabled ? '/addons' : null, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  return {
    addons: Array.isArray(data?.data) ? data.data : [],
    error,
    isLoading
  };
}

export function useInitiateAddon() {
  const { post, isMutating } = useMutate('/payment/initiate/addon');

  const initiateAddon = async ({ addon_slug, billing_cycle }) => {
    const res = await post({
      addon_slug,
      billing_cycle
    });

    return { gateway: res?.gateway, ...(res?.data ?? {}) };
  };

  return {
    initiateAddon,
    isMutating
  };
}
